module.exports = __webpack_public_path__ + "img/about_banner_img1.eee14a87.png";